module.exports = __webpack_public_path__ + "media/images/icons/filled/meh-05043af364167230714e3c2081b1738c.svg";